const validationRegEx = /^([0-9]{1,3}-)?(\d{3}-\d{3}-\d{4})$/

export function phoneInputIsValid(input: string) {
  return validationRegEx.test(input)
}
